const PREFIX = '[Velvynote]';
const isDev = process.env.NODE_ENV === 'development';

function emit(level, consoleFn, args) {
  const ts = new Date().toISOString();
  consoleFn(`${ts} ${level} ${PREFIX}`, ...args);
}

export const logger = {
  debug(...args) {
    if (!isDev) return;
    emit('DEBUG', console.debug, args);
  },
  info(...args) {
    if (!isDev) return;
    emit('INFO', console.info, args);
  },
  warn(...args) {
    emit('WARN', console.warn, args);
  },
  error(...args) {
    emit('ERROR', console.error, args);
  },
};
